<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="StudentReqForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>Generate DTR</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 900px" class="">
            <v-container>
              <v-row>
                <v-col :cols="$vuetify.display.smAndDown ? 12 : 5">
                  <v-text-field
                    label="Date From"
                    :model-value="formatDate(date_from)"
                    variant="outlined"
                    density="compact"
                    readonly
                    :rules="[formRules.required]"
                    @click="showDatePicker1 = true"
                  ></v-text-field>

                  <v-dialog v-model="showDatePicker1" max-width="290">
                    <v-date-picker
                      v-model="date_from"
                      @update:model-value="saveDateFrom"
                      :color="$vuetify.theme.themes.light.inputColor"
                    ></v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col :cols="$vuetify.display.smAndDown ? 12 : 5">
                  <v-text-field
                    label="Date To"
                    :model-value="formatDate(date_to)"
                    variant="outlined"
                    density="compact"
                    readonly
                    :rules="[formRules.required]"
                    @click="showDatePicker2 = true"
                  ></v-text-field>

                  <v-dialog v-model="showDatePicker2" max-width="290">
                    <v-date-picker
                      :disabled="!date_from"
                      v-model="date_to"
                      :min="date_from"
                      :max="getmaxDate"
                      @update:model-value="saveDateTo"
                      :color="$vuetify.theme.themes.light.inputColor"
                    ></v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col :cols="$vuetify.display.smAndDown ? 12 : 2">
                  <v-btn
                    :color="$vuetify.theme.themes.light.submitBtnsGreen"
                    class="white--text"
                    density="comfortable"
                    variant="flat"
                    :loading="btnLoading"
                    :disabled="btnLoading"
                    @click="loadDTR()"
                  >
                    <v-icon>mdi-check-circle</v-icon>
                    Load DTR
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <div class="pa-2">
                    <div class="text-center">
                      <div class="text-subtitle-1 font-weight-bold">
                        Davao del Norte State College
                      </div>
                      <div class="text-caption">
                        New Visayas, Panabo City, Davao del Norte, Philippines
                      </div>
                      <div class="my-4 text-uppercase">Daily time record</div>
                    </div>

                    <div class="text-subtitle-1 font-weight-bold">
                      Name:
                      <span style="text-decoration: underline">{{
                        data && data.name
                      }}</span>
                    </div>

                    <div class="text-subtitle-1 font-weight-bold my-4">
                      Month:
                      <span style="text-decoration: underline">{{
                        getMonthYear
                      }}</span>
                    </div>
                    <div>
                      <table id="dtrTbl">
                        <thead>
                          <tr>
                            <td rowspan="2">Date</td>
                            <td colspan="2">MORNING</td>
                            <td colspan="2">AFTERNOON</td>
                            <td colspan="2">OVERTIME</td>
                            <td rowspan="2">Daily Total</td>
                            <td rowspan="2">Signature</td>
                          </tr>
                          <tr>
                            <td>AM IN</td>
                            <td>AM OUT</td>
                            <td>AM IN</td>
                            <td>AM OUT</td>
                            <td>AM IN</td>
                            <td>AM OUT</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="i in dtrData" :key="i">
                            <td align="center" class="text-caption">
                              {{ i.day }}
                            </td>
                            <td align="center" class="text-caption">
                              {{ i.am_in ? formatTime(i.am_in) : null }}
                            </td>
                            <td align="center" class="text-caption">
                              {{ i.am_out ? formatTime(i.am_out) : null }}
                            </td>
                            <td align="center" class="text-caption">
                              {{ i.pm_in ? formatTime(i.pm_in) : null }}
                            </td>
                            <td align="center" class="text-caption">
                              {{ i.pm_out ? formatTime(i.pm_out) : null }}
                            </td>
                            <td align="center" class="text-caption">
                              {{ i.ot_in ? formatTime(i.ot_in) : null }}
                            </td>
                            <td align="center" class="text-caption">
                              {{ i.ot_out ? formatTime(i.ot_out) : null }}
                            </td>
                            <td align="center" class="text-caption">
                              {{ i.daily_total }}
                            </td>
                            <td align="center" class="text-caption"></td>
                          </tr>
                          <tr>
                            <td
                              align="center"
                              colspan="7"
                              class="text-caption font-weight-bold"
                            >
                              TOTAL
                            </td>
                            <td colspan="2" align="center" class="text-caption">
                              {{ hrs_total }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
  },
  components: {},
  data() {
    return {
      dialog: false,
      date_from: null,
      date_to: null,
      dtrData: [],
      btnLoading: false,
      deletedFile: null,
      url: null,
      showDatePicker1: false,
      showDatePicker2: false,
      showRemarksDialog: false,
      hasDTRData: false,
      hrs_total: 0,
      org: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },

  computed: {
    getmaxDate() {
      const date = new Date(this.date_from);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      return lastDay.toISOString().split("T")[0];
    },

    getMonthYear() {
      let mnthYr = "";
      let monthFull = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      if (this.date_from && this.date_to) {
        let d = new Date(this.date_from);
        mnthYr = monthFull[d.getMonth()] + ", " + d.getFullYear();
      }
      return mnthYr;
    },

    getStudentname() {
      const { fname, mname, lname } = this.$store.state.user;
      return fname + " " + (mname ? mname[0] + ". " : " ") + lname;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        console.log("View", data);
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.dtrData = [];
      for (let i = 1; i <= 31; i++) {
        this.dtrData.push({
          day: i,
          am_in: null,
          am_out: null,
          pm_in: null,
          pm_out: null,
          daily_total: null,
        });
      }
    },

    saveDateFrom() {
      if (this.date_from) {
        this.date_from = this.formatDate3(this.date_from);
        this.showDatePicker1 = false;
      }
    },

    saveDateTo() {
      if (this.date_to) {
        this.date_to = this.formatDate3(this.date_to);
        this.showDatePicker2 = false;
      }
    },

    loadDTR() {
      if (this.date_from && this.date_to) {
        let url;
        let type;

        url = `/attendance/student/${this.data.id}?date_from=${this.date_from}&date_to=${this.date_to}`;
        type = "GET";

        this.axiosCall(url, type).then((res) => {
          console.log(res.data);
          if (res.data.length > 0) {
            this.hasDTRData = true;
            this.syncDTR(res.data);
          }
        });
      }
    },

    syncDTR(data) {
      for (let i = 0; i < this.dtrData.length; i++) {
        for (let j = 0; j < data.length; j++) {
          let d = new Date(data[j].date);
          if (this.dtrData[i].day == d.getDate()) {
            this.dtrData[i].am_in = data[j].am_in;
            this.dtrData[i].am_out = data[j].am_out;
            this.dtrData[i].pm_in = data[j].pm_in;
            this.dtrData[i].pm_out = data[j].pm_out;
            this.dtrData[i].daily_total = data[j].total_hours;
            this.hrs_total += parseFloat(data[j].total_hours);
          }
        }
      }
    },

    closeD() {
      //   URL.revokeObjectURL();
      eventBus.emit("closeViewStudentDTRDialog", true);

      this.dialog = false;
    },
  },
};
</script>

<style scoped>
#dtrTbl {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}
#dtrTbl thead td,
#dtrTbl tbody td {
  border: 1px solid black;
  font-size: 12px;
  text-align: center;
}
</style>
